import { createActions } from 'redux-actions';

export const { initializeApp, completedInitializeApp, pageLoaded } = createActions({
    initializeApp:          () => void 0,
    completedInitializeApp: () => void 0,

    pageLoaded: () => void 0,
});
